import api from "./api";

const USERS_PATH = "/auth/users";

export async function listUsers() {
  const { data } = await api.get(USERS_PATH);
  return data;
}

export async function createUser(payload) {
  const { data } = await api.post(USERS_PATH, payload);
  return data;
}

export async function updateUser(userId, payload) {
  const { data } = await api.patch(`${USERS_PATH}/${encodeURIComponent(userId)}`, payload);
  return data;
}

export async function resetStaffPassword(userId) {
  const { data } = await api.post(
    `${USERS_PATH}/${encodeURIComponent(userId)}/reset-password`
  );
  return data;
}
